import { useMemo } from "react";

import { getFilterByType } from "@apps/reporting/components/engagement-survey-report/helpers";
import {
  EngagementSurveyReportFilterType,
  EngagementSurveyReportGraphQLFilters,
  EngagementSurveyReportViewOptions,
} from "@apps/reporting/components/engagement-survey-report/types";

const useSurveyReportFilters = ({
  viewOptions,
}: {
  viewOptions: EngagementSurveyReportViewOptions;
}): EngagementSurveyReportGraphQLFilters => {
  return useMemo(() => {
    const teamIdsFilter = getFilterByType(
      viewOptions.filters.list,
      EngagementSurveyReportFilterType.TEAM,
    );
    const managerIdsFilter = getFilterByType(
      viewOptions.filters.list,
      EngagementSurveyReportFilterType.REPORTS_TO,
    );
    const managerIdsFullTreeFilter = getFilterByType(
      viewOptions.filters.list,
      EngagementSurveyReportFilterType.REPORTS_TO_FULL_TREE,
    );
    const employeeStartDateRangeFilter = getFilterByType(
      viewOptions.filters.list,
      EngagementSurveyReportFilterType.EMPLOYEE_START_DATE,
    );
    const locationsFilter = getFilterByType(
      viewOptions.filters.list,
      EngagementSurveyReportFilterType.LOCATION,
    );
    return {
      teamIdsFilter: teamIdsFilter ? teamIdsFilter.map(({ id }) => id) : [],
      managerIdsFilter: managerIdsFilter
        ? managerIdsFilter.map(({ id }) => id)
        : [],
      managerIdsFullTreeFilter: managerIdsFullTreeFilter
        ? managerIdsFullTreeFilter.map(({ id }) => id)
        : [],
      employeeStartDateRangeFilter: employeeStartDateRangeFilter
        ? employeeStartDateRangeFilter
        : [null, null],
      locationsFilter: locationsFilter ? locationsFilter : [],
    };
  }, [viewOptions.filters.list]);
};

export default useSurveyReportFilters;
